import React from 'react';
import { connect } from 'react-redux';
import find from 'lodash.find';

import {
  setColumnBackgroundColor,
  setColumnPadding
} from '../actions/column-actions';

export const ColumnOptions = ({
  onBackgroundColorChange,
  onPaddingChange,
  options = {},
}) => {
  const { backgroundColor = '#ffffff', padding = 0 } = options;

  const handleBackgroundColorChange = e => onBackgroundColorChange(e.target.value);
  const handlePaddingChange = e => onPaddingChange(e.target.value);

  return (
    <div>
      <header>Background color:</header>
      <input type="color" value={backgroundColor} onChange={handleBackgroundColorChange} />
      <header>Padding:</header>
      <input type="range" min="0" max="50" value={padding} onChange={handlePaddingChange} />
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { device, id } = ownProps,
        container = state.model[device].present,
        row = find(container.rows, r => find(r.columns, c => c.id === id)),
        column = find(row.columns, c => c && c.id === id);

  return {
    ...column,
    rowId: row.id
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { device, id: columnId } = ownProps;

  return {
    onBackgroundColorChange(rowId, color) {
      dispatch(setColumnBackgroundColor({ device, rowId, columnId, color }));
    },

    onPaddingChange(rowId, padding) {
      dispatch(setColumnPadding({ device, rowId, columnId, padding }));
    }
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const rowId = stateProps.rowId;

  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    onBackgroundColorChange: dispatchProps.onBackgroundColorChange.bind(null, rowId),
    onPaddingChange: dispatchProps.onPaddingChange.bind(null, rowId)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ColumnOptions);



// WEBPACK FOOTER //
// ./app/header-builder/components/ColumnOptions.js